import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useSocialLinks } from "../hooks/usePortfolioData";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  const { socialLinks } = useSocialLinks();

  // Fallback to default values if not loaded or unavailable
  const email = socialLinks?.email || "firasbayoudhi@gmail.com";
  const github = socialLinks?.github || "https://github.com/bayoudhif";
  const linkedin = socialLinks?.linkedin || "https://www.linkedin.com/in/bayoudhi/";
  const instagram = socialLinks?.instagram || "https://www.instagram.com/bayoudhi.f/";

  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>
            If you are interested in contacting me, email me at {email}.
          </h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} FB</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            {github && (
              <li className="social-icons">
                <a
                  href={github}
                  className="footer-social-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillGithub />
                </a>
              </li>
            )}
            {linkedin && (
              <li className="social-icons">
                <a
                  href={linkedin}
                  className="footer-social-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            )}
            {instagram && (
              <li className="social-icons">
                <a
                  href={instagram}
                  className="footer-social-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillInstagram />
                </a>
              </li>
            )}
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
